export default function snippet80(text) {
  if (text && text.toString().length > 80) {
    return text.toString().substring(0, 80) + '...'
  } else if (!text) {
    return ''
  } else {
    return text
  }
}
